module.exports = __webpack_public_path__ + "static/media/post-img6.ac59698e.jpg";